import styled from 'styled-components';
import { Tooltip as ExternalTooltip } from 'react-tooltip';

export const Div = styled.div`
  svg {
    outline: none;
  }

  .react-tooltip {
    font-size: 14px !important;
    font-weight: 400 !important;
    color: ${({ theme }) => theme.colors.white} !important;
    background-color: ${({ theme }) => theme.colors.prussianBlue} !important;
  }

  .tooltip-children-inline {
    display: inline-flex;
    align-items: center;
    width: fit-content;
  }
`;

export const StyledTooltip = styled(ExternalTooltip)`
  * {
    word-break: break-word;
    overflow-wrap: break-word;
    word-wrap: break-word;
  }
`;
